<template>
  <div class="users-picker-wrapper">
    <v-tooltip bottom v-if="isBtn">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" @click="dialog = true">
          <v-icon>mdi-account-search</v-icon>
        </v-btn>
      </template>
      <span>{{ title }}</span>
    </v-tooltip>

    <v-text-field
      v-else
      :label="title"
      :value="name"
      readonly
      append-icon="mdi-crosshairs"
      @click="dialog = true"
      @click:append="dialog = true"
      :hide-details="hideDetails"
      outlined
      dense
    />

    <custom-popup
      v-model="dialog"
      :cons="cons"
    >
      <v-card-text class="pb-0">
        <v-row>
          <v-col cols="12" md="3" sm="6">
            <v-text-field
              label="جستجوی کلی"
              append-icon="mdi-magnify"
              clear-icon="mdi-close-circle-outline"
              v-model="tableProps.search"
              outlined
              hide-details
              dense
              clearable
              @keydown.enter="executeSearch()"
              @click:append="executeSearch()"
              @click:clear="$nextTick(() => executeSearch())"
            />
          </v-col>
          <v-col cols="12" md="3" sm="6">
            <v-text-field
              label="شناسه"
              append-icon="mdi-magnify"
              clear-icon="mdi-close-circle-outline"
              v-model="tableProps.id"
              type="number"
              outlined
              hide-details
              dense
              clearable
              @keydown.enter="executeSearch()"
              @click:append="executeSearch()"
              @click:clear="$nextTick(() => executeSearch())"
            />
          </v-col>
          <v-col cols="12" md="3" sm="6">
            <v-text-field
              label="نام"
              append-icon="mdi-magnify"
              clear-icon="mdi-close-circle-outline"
              v-model="tableProps.name"
              outlined
              hide-details
              dense
              clearable
              @keydown.enter="executeSearch()"
              @click:append="executeSearch()"
              @click:clear="$nextTick(() => executeSearch())"
            />
          </v-col>
          <v-col cols="12" md="3" sm="6">
            <v-text-field
              label="نام خانوادگی"
              append-icon="mdi-magnify"
              clear-icon="mdi-close-circle-outline"
              v-model="tableProps.lastName"
              outlined
              hide-details
              dense
              clearable
              @keydown.enter="executeSearch()"
              @click:append="executeSearch()"
              @click:clear="$nextTick(() => executeSearch())"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <!-- لیست کاربران -->
      <v-card-text class="pt-4">
        <div v-if="loading" class="text-center py-4">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        
        <v-list v-else dense class="overflow-y-auto" style="max-height: 300px;">
          <v-list-item-group v-model="picked" color="primary">
            <v-list-item v-for="(item, i) in manufacturers" :key="i" :value="item">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.name }} {{ item.lastName }}
                  <span v-if="item.id" class="grey--text text-caption ml-2">(شناسه: {{ item.id }})</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card-text>

      <!-- صفحه‌بندی -->
      <div class="text-center py-2" v-if="data.last_page && data.last_page > 1">
        <v-pagination
          v-model="tableProps.page"
          :length="data.last_page"
          @input="onPagination"
          total-visible="7"
        ></v-pagination>
      </div>
    </custom-popup>
  </div>
</template>

<script>
export default {
  name: "usersPicker",
  props: {
    title: {
      type: String,
      default: "انتخاب کاربر",
    },
    value: {
      type: [Number, String],
      default: null,
    },
    oldData: {
      type: Object,
      default: () => null,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    isBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cons: {
 title: "تغییر معرف",
      buttons: [
        { 
          type: "submit", 
          text: "تایید", 
          disabled: true,
          handler: () => this.pick() 
            }]
                },
      selectedItem: null,
      dialog: false,
      loading: false,
      manufacturers: [],
      data: {},
      picked: null,
      name: "",
      model: null,
      tableProps: {
        page: 1,
        search: "",
        id: "",
        name: "",
        lastName: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      url: "admin/users",
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.fetch(this.url);
      }
    },
    picked(val) {
      let obj = this.cons.buttons.find((item) => item.type === "submit");
      if (obj) obj.disabled = !val;
    },
    oldData(val) {
      if (val) {
        setTimeout(() => {
          this.pick(val);
        }, 1000);
      }
    },
  },
  methods: {
    executeSearch() {
      this.tableProps.page = 1;
      this.fetch();
    },

    fetch(url = this.url, props = this.tableProps) {
      this.loading = true;
      try {
        const search = props.search || "";
        const id = props.id || "";
        const firstName = props.name || "";
        const lastName = props.lastName || "";

        let endpoint = `${url}?page=${props.page}&length=${props.length}&column=${props.column}&dir=${props.dir}&search=${search}&id=${id}&name=${firstName}&lastName=${lastName}`;

        this.requestApiGet(endpoint)
          .then(({ data }) => {
            this.data = data;
            this.picked = null;
            this.selectedItem = null;

            this.manufacturers = [
              {
                id: null,
                name: "ندارد",
                lastName: "",
                username: null,
              },
            ];

            if (data && data.data) {
              this.manufacturers = this.manufacturers.concat(data.data);
            }
          })
          .catch(({ response }) => {
            if (this.$toast) this.$toast.error("خطا در دریافت کاربران!");
          })
          .finally(() => {
            this.loading = false;
          });
      } catch (e) {
        console.log("error in get users: ", e);
        this.loading = false;
      }
    },

    delContact() {
      this.dialog = false;
      this.model = null;
      this.name = "";
    },

    pick(x = this.picked) {
      if (!x) return;
      this.name = (x.name || "") + " " + (x.lastName || "");
      this.$emit("input", x.id);
      this.dialog = false;
    },

    onPagination(e) {
      this.tableProps.page = e;
      this.fetch();
    },
  },
};
</script>

<style scoped>
</style>
